export default class CoreTitle {
  constructor(parent) {
    this.$parent = parent;
    this.value = '';
  }

  get language() {
    return this.$parent.language;
  }

  set(value) {
    if (this.$parent.show) {
      document.title = this.language.get(value || this.value);
    }
    if (value) {
      this.value = value;
    }
  }

  get() {
    return document.title;
  }
}
